import { render, staticRenderFns } from "./DpSeite.vue?vue&type=template&id=3b1e5084&scoped=true&"
import script from "./DpSeite.vue?vue&type=script&lang=js&"
export * from "./DpSeite.vue?vue&type=script&lang=js&"
import style0 from "./DpSeite.vue?vue&type=style&index=0&id=3b1e5084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e5084",
  null
  
)

export default component.exports